class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class MegaMenuContent extends HTMLElement {
  connectedCallback() {
    this.detailsEls = this.querySelectorAll('.mega-menu__details');
    this.mainLinkEls = this.querySelectorAll('.mega-menu__link--level-2');
    let maxHeight = 0;
    this.detailsEls.forEach((detailsEl) => {
      if (detailsEl.offsetHeight > maxHeight) {
        maxHeight = detailsEl.offsetHeight;
      }
    });
    this.mainLinkEls.forEach((link) => {
      link.addEventListener('mouseenter', this.onMainLinkHover.bind(this));
    });
  }

  onMainLinkHover(event) {
    event.preventDefault();
    const id = event.currentTarget.id;
    this.detailsEls.forEach((detail) => {
      if (detail.id === `${id}-Content`) {
        detail.removeAttribute('hidden');
      } else {
        detail.setAttribute('hidden', '');
      }
    });
    this.mainLinkEls.forEach((linkEl) => {
      if (linkEl.id === id) {
        linkEl.classList.add('mega-menu__link--active');
      } else {
        linkEl.classList.remove('mega-menu__link--active');
      }
    });
  }
}

customElements.define('mega-menu-content', MegaMenuContent);

class HeaderContact extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-contact', HeaderContact);
